import Chart from 'chart.js/auto';

export default class StateProfile {

  constructor(customerComparisonData, consumptionComparisonData) {

    // Create the charts.
    this.createChart('chart-customer-comparison', 'chart-legend-customer-comparison', customerComparisonData);
    this.createChart('chart-consumption-comparison', 'chart-legend-consumption-comparison', consumptionComparisonData);
  }

  /**
   * A callback to run after the chart has initialized.
   */
  onChartInitPlugin() {
    return {
      id: 'afterInitHook',
      afterInit: function(chart) {

        // Add an `active` class to the chart's wrapper element.
        chart.canvas.closest('.chart__chart').classList.add('active');
      },
    };
  }

  /**
   * Create the custom legend.
   */
  htmlLegendPlugin() {

    // Get or create the legend list.
    function getOrCreateLegendList(chart, id) {
      const legendContainer = document.getElementById(id);
      let listContainer = legendContainer.querySelector('ul');

      if (! listContainer) {
        listContainer = document.createElement('ul');
        listContainer.style.display = 'grid';
        listContainer.style.gridTemplateColumns = '1fr 1fr';
        listContainer.style.margin = 0;
        listContainer.style.padding = 0;

        legendContainer.appendChild(listContainer);
      }

      return listContainer;
    }

    // Return the config object.
    return {
      id: 'htmlLegend',
      afterUpdate(chart, args, options) {
        const ul = getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach(item => {
          const li = document.createElement('li');
          li.style.alignItems = 'center';
          li.style.cursor = 'pointer';
          li.style.display = 'flex';
          li.style.flexDirection = 'row';
          li.style.margin = '0';
          li.style.position = 'relative';

          // Color box
          const boxSpan = document.createElement('span');
          boxSpan.classList.add('color-box');
          boxSpan.style.background = item.fillStyle;
          boxSpan.style.borderColor = item.strokeStyle;
          boxSpan.style.borderWidth = item.lineWidth + 'px';
          boxSpan.style.display = 'inline-block';
          boxSpan.style.flexShrink = 0;
          boxSpan.style.height = '11px';
          boxSpan.style.marginRight = '8px';
          boxSpan.style.width = '11px';
          boxSpan.style.borderRadius = '22px';

          // Add the tooltip text.
          const textContainer = document.createElement('span');
          textContainer.classList.add('value')

          const text = document.createTextNode(item.text);
          textContainer.appendChild(text);

          li.appendChild(boxSpan);
          li.appendChild(textContainer);
          ul.appendChild(li);

          // Create the tooltip.
          const tooltip = document.createElement('div');
          tooltip.classList.add('chart-tooltip');
          li.appendChild(tooltip);

          // Show the tooltip on mouseover.
          li.addEventListener('mouseover', () => {

            const value = chart.data.datasets[0].data[item.index];

            const tooltip = li.querySelector('.chart-tooltip')
            tooltip.innerHTML = new Intl.NumberFormat('en-US').format(value);
            tooltip.classList.add('active');
          });

          li.addEventListener('mouseout', () => {
            li.querySelector('.chart-tooltip').classList.remove('active')
          });
        });
      }
    }
  }

  /**
   * Create a chart.
   */
  createChart(chartId, legendId, chartData) {

    const ctx = document.getElementById(chartId);
    const chartLegendId = legendId;

    const chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: ['Residential', 'Commercial', 'Industrial', 'Electric Utility'],
        datasets: [{
          data: chartData,
          backgroundColor: [
            '#002642',
            '#D6E288',
            '#FFFFFF',
            '#5FA7FF',
          ],
          borderWidth: 0,
        }]
      },
      plugins: [
        this.onChartInitPlugin(),
        this.htmlLegendPlugin(),
      ],
      options: {
        rotation: -80,
        plugins: {
          htmlLegend: {
            containerID: chartLegendId,
          },
          legend: {
            display: false,
            labels: {
              usePointStyle: true,
              color: '#FFFFFF',
            },
          },
          tooltip: {
            enabled: false, 
            external: function(context) {

              // Tooltip Element
              let tooltipEl = document.getElementById('chart-tooltip');

              // Create element on first render.
              if (! tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chart-tooltip';
                tooltipEl.classList.add('chart-tooltip');
                document.querySelector('.state-profile-data').appendChild(tooltipEl);
              }

              // Hide if no tooltip.
              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              // Set tooltip text.
              tooltipEl.innerHTML = context.tooltip.dataPoints[0].formattedValue;

              // Display and position.
              const position = context.chart.canvas.getBoundingClientRect();
              tooltipEl.style.opacity = 1;
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            }
          }
        }
      }
    });
  }
}
